import removeIeFormElement from '../util/removeIeFormElement';
import HbGuideForm from '../svelte/HbGuideForm.svelte';

export default {
  init() {
    // remove IE HBGuide form
    removeIeFormElement('#hb-guide-form-ie');

    // for accessing localized variables from PHP
    const sanctum = window.sanctum;

    // instantiate Svelte component
    new HbGuideForm({
      target: document.querySelector('#hb-guide-form'),
      props: {
        // account, campaign prefix, source name, & company are used in LoanForce API call to create contact
        account: sanctum.account,
        loanforceId: sanctum.loanforce_id,
        campaignPrefix: sanctum.campaign_prefix,
        sourceName: sanctum.source_name,
        // company name displayed in disclaimer text below form
        company: sanctum.company,
        // completing the form gives user access to HB Guide PDF
        hbguideUrl: sanctum.hbguide_url,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/buyAHome.js